import { Dayjs } from "dayjs"

export function determineEndDate(start: Dayjs, totalHours: number, hoursPerDay: number, workDays: number[]): Dayjs {
  if (workDays.length === 0) {
    return start
  }

  const daysToWork = Math.ceil(totalHours / hoursPerDay)

  let current = start
  while (!workDays.includes(current.day())) {
    current = current.add(1, "day")
  }

  if (daysToWork <= 1) {
    return current
  }

  let remaining = daysToWork - 1
  while (remaining > 0) {
    const fullWeeksToSkip = Math.floor(remaining / workDays.length)
    if (fullWeeksToSkip > 0) {
      current = current.add(fullWeeksToSkip * 7, "day")
      remaining -= fullWeeksToSkip * workDays.length
    } else {
      current = current.add(1, "day")
      if (workDays.includes(current.day())) {
        remaining--
      }
    }
  }

  return current
}

export function getTotalEstimatedHours(workareas: { estimatedHours: number }[]): number {
  return workareas.reduce((sum, wa) => sum + wa.estimatedHours, 0)
}
